import * as React from 'react';

import { RadioButtonGroup } from '../../RadioButtonGroup';
import { Filter } from '../common/Filter';

interface ICeilingHeight {
  label: string;
  value: number | null;
}

const CEILING_HEIGHTS: ICeilingHeight[] = [
  { label: 'Неважно', value: null },
  { label: 'От 2,5 м', value: 2.5 },
  { label: 'От 2,7 м', value: 2.7 },
  { label: 'От 3 м', value: 3 },
  { label: 'От 3,5 м', value: 3.5 },
  { label: 'От 4 м', value: 4 },
];

interface ICeilingHeightProps {
  value: number | null;
  onChange(value: number): void;
}

export const CeilingHeight: React.FC<ICeilingHeightProps> = ({ value, onChange }) => {
  return (
    <Filter id="advancedFilter_ceilingHeight" label="Высота потолков">
      <RadioButtonGroup options={CEILING_HEIGHTS} value={value} onChange={onChange} spliced={false} />
    </Filter>
  );
};
